import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {AuthService} from '../../core/security/auth.service';
import {merge} from 'rxjs';
import {RolesEnum} from '../../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {HolidayGreetingsService as HolidayGreetingsApiService} from '../../api/services/holiday-greetings.service';
import {HolidayGreetingsDatasource} from './holiday-greetings.datasource';
import {HolidayGreetingsListRequest} from '../../api/models/holiday-greetings-list-request';
import {NotificationService} from '../../notification/notification.service';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { AudioControlComponent } from '../../core/visual/audio-control/audio-control.component';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { HolidaysRangePipe } from './holidays-range.pipe';

@Component({
    selector: 'app-holiday-greetings-grid',
    templateUrl: './holiday-greetings-grid.component.html',
    styleUrls: ['./holiday-greetings-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        RouterLink,
        NgFor,
        MatButton,
        MatTooltip,
        MatIcon,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AudioControlComponent,
        AsyncPipe,
        PhoneNumberPipe,
        HolidaysRangePipe,
    ],
})
export class HolidayGreetingsGridComponent implements OnDestroy, OnInit, AfterViewInit {
  displayedColumns: string[] = ['account', 'displayName', /*'ani',*/ 'alias', 'holidayDisplay', 'audio', 'status'];
  @Input() filterChangeEvent: EventEmitter<void>;
  @Input() showAdditionalColumns = false;
  hasSupportAccess = false;
  additionalFilter: any = {};
  recIdFilter: string;
  isLoading = false;
  searchText: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: HolidayGreetingsDatasource;
  detailsUrl: string;
  hasEditAccess: boolean;
  currentAudioSource: string;
  currentAudioDownloadSource: string;

  constructor(public dialog: MatDialog,
              private pbxApiService: HolidayGreetingsApiService,
              private notificationService: NotificationService,
              private route: ActivatedRoute, public headerService: HeaderService, public authService: AuthService) {
  }

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.hasEditAccess = this.authService.hasAccess([RolesEnum.PbxHolidayGreetings_Edit, RolesEnum.PbxHolidayGreetings_Delete]);
    this.dataSource = new HolidayGreetingsDatasource(this.pbxApiService);

    this.detailsUrl = '../ipaddress';
  }

  ngAfterViewInit() {
    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): HolidayGreetingsListRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  async playRecording(account: string) {
    this.currentAudioSource = `/api/holiday-greetings/audio/stream/${account}/?t=${new Date().getTime()}`;
    this.currentAudioDownloadSource = `api/holiday-greetings/audio/download/${account}`;
  }

  onAudioError(event: any) {
    console.log(event);
    this.notificationService.notifyDanger('Recording file isn\'t available');
  }

  ngOnDestroy() {
  }
}
